// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyD7txJlti4cF9ALCLR7g9_KHs72Iu_XeBQ',
    authDomain: 'mobblepay-e2244.firebaseapp.com',
    databaseURL: 'https://mobblepay-e2244.firebaseio.com',
    projectId: 'mobblepay-e2244',
    storageBucket: 'mobblepay-e2244.appspot.com',
    messagingSenderId: '215204490933',
    appId: '1:215204490933:web:50dbe813689931067598fc',
    measurementId: 'G-XQP2GVM5Z0'
  }
};*/

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAcPAISxZhmuY0a64LInu8H68yncY5_yIA',
    authDomain: 'mobble-prod.firebaseapp.com',
    databaseURL: 'https://mobble-prod.firebaseio.com',
    projectId: 'mobble-prod',
    storageBucket: 'mobble-prod.appspot.com',
    messagingSenderId: '92637725876',
    appId: '1:92637725876:web:6a7a41874ac4f2f0a3c3e1',
    measurementId: 'G-QCP0PW4R4V'
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
